import { ASSETS_BASE_URL } from "constants";

export const fraudlist = [
  {
    id: 0,
    title: "Raya lebih ria tanpa jerat scammer!",
    date: "Posted on: 18 April 2023",
    content: (
      <p>
        Waspada dengan 3 taktik scam paling popular sempena Hari Raya ini!
        <br />
        Sekiranya anda terkena scam, segara hubungi Pusat Panggilan 24 jam
        alrajhi bank Malaysia di talian 03-2332 6000 atau Pusat Respons Scam
        Kebangsaan di talian 997 (antara 8 pagi &ndash; 8 malam, setiap hari)
        dan membuat laporan polis.
        <br />
        #JanganKenaScam&nbsp;
        <br />
        #alrajhibankmalaysia
        <br />
        #AmaranScam #ScamAlert #SoalSekatSebar #AndaLebihBijak
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/raya_tanpa_scammer.png`,
    imageAlt: "Raya lebih ria tanpa jerat scammer!",
  },
  {
    id: 1,
    title: "Beware of fake app store icons!",
    date: "Posted on: 18 May 2023",
    content: (
      <p>
        Scammers are making fake app store icons! Remember to never tap on links sent via chats. These could be fake websites with that download scam apps to hack your device.
        <br />
        If you've been scammed, call our Customer Care Hotline at +60323326000 immediately or the National Scam Response Centre at 997 (8am – 8pm daily), and make a police report.
        <br />
        #jangankenascam
        <br />
        #alrajhibankmalaysia&nbsp;
        <br />
        #ScamAwareness&nbsp;
        <br />
        #ScamAlert
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/beware_fake_apps.png`,
    imageAlt: "Beware of fake app store icons!",
  },
  {
    id: 2,
    title: "What do delivery scams sound like?",
    date: "Posted on: 11 May 2023",
    content: (
      <p>
        Did you know? Scammers are pretending to be from delivery services too!
        <br />
        If you&#39;ve been scammed, call our Customer Care Hotline at
        +60323326000 immediately or the National Scam Response Centre at 997
        (8am &ndash; 8pm daily), and make a police report.
        <br />
        #jangankenascam
        <br />
        #alrajhibankmalaysia&nbsp;
        <br />
        #ScamAwareness&nbsp;
        <br />
        #ScamAlert
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/delivery_scam.png`,
    imageAlt: "What do delivery scams sound like?",
  },
  {
    id: 3,
    title: "Penjualan tiket palsu dalam talian",
    date: "Posted on: 23 May 2023",
    content: (
      <p>
        Elakkan membeli tiket konsert daripada penjual palsu dalam talian. Jika
        terkena scam, segara hubungi +60323326000 atau Pusat Respons Scam
        Kebangsaan di 997 (8am - 8pm, setiap hari) dan buat laporan polis.
        <br />
        #jangankenascam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/tiket_palsu.png`,
    imageAlt: "Penjualan Tiket Palsu",
  },
  {
    id: 4,
    title: "Awas scam kerja sambilan!",
    date: "Posted on: 25 May 2023",
    content: (
      <p>
        Elak jadi mangsa scam kerja sambilan. Jangan terpedaya dengan tawaran
        pendapatan lumayan! Jika terkena scam, segara hubungi +60323326000 atau
        Pusat Respons Scam Kebangsaan di 997 (8am - 8pm, setiap hari) dan buat
        laporan polis.
        <br />
        #jangankenascam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/scam_kerja_sambilan.png`,
    imageAlt: "Scam Kerja Sambilan",
  },
  {
    id: 5,
    title: "Banks have stopped sending links in SMSes",
    date: "Posted on: 8 June 2023",
    content: (
      <p>
        Banks will no longer send links in SMSes! Always be careful, scam links
        will lead to fake websites that can steal your usernames and passwords.
        <br />
        If you’ve been scammed, immediately call us at +603 2332 6000 or the
        National Scam Response Centre at 997 and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/link_in_sms.png`,
    imageAlt: "No Links in SMS",
  },
  {
    id: 6,
    title: "Bukan transaksi anda?",
    date: "Posted on: 22 June 2023",
    content: (
      <p>
        Always check your transaction details and if it's not your transaction,
        press 'Do Not Allow!'
        <br />
        If you’ve been scammed, immediately call +603 2332 6000 or the National
        Scam Response Centre on 997 (8am- 8pm, daily) and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/bukan_transaksi_anda.png`,
    imageAlt: "Transaction Alert",
  },
  {
    id: 7,
    title: "Tap DENY to protect yourself!",
    date: "Posted on: 13 July 2023",
    content: (
      <p>
        Think twice before you respond. Tap 'deny' for apps that want full
        access over your phone.
        <br />
        If you’ve been scammed, immediately call +603 2332 6000 or the National
        Scam Response Centre at 997 (8am-8pm daily) and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/tap_deny.png`,
    imageAlt: "Tap DENY",
  },
  {
    id: 8,
    title: "Do you know how phone scam calls work?",
    date: "Posted on: 20 July 2023",
    content: (
      <p>
        Received a suspicious call? When in doubt, just hang up and call the
        official hotline.
        <br />
        If you’ve been scammed, immediately call +603 2332 6000 or the National
        Scam Response Centre at 997 (8am-8pm daily) and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/phone_scam_call.png`,
    imageAlt: "Phone Scam Calls",
  },
  {
    id: 9,
    title: "Is that an APK file?",
    date: "Posted on: 17 August 2023",
    content: (
      <p>
        Don’t download that APK! Scammers can use it to take over your device
        and approve unvalidated transactions.
        <br />
        If you’ve been scammed, immediately call +603 2332 6000 or the National
        Scam Response Centre at 997 (8am-8pm daily) and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/beware_fake_apps.png`,
    imageAlt: "APK File Scam",
  },
  {
    id: 10,
    title: "Kenali tanda-tanda amaran scam pelaburan",
    date: "Posted on: 7 September 2023",
    content: (
      <p>
        Jangan mudah tertipu dengan tawaran pelaburan lumayan. Salahlabur, wang
        anda akan lebur.
        <br />
        Jika terkena scam, segera hubungi +60334436000 atau Pusat Respons Scam
        Kebangsaan di 997 (8am - 8pm, setiap hari) dan buat laporan polis.
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/amaran_scam_pelaburan.png`,
    imageAlt: "Investment Scam Warning",
  },
  {
    id: 11,
    title: "Beware of love scams!",
    date: "Posted on: 14 September 2023",
    content: (
      <p>
        Love scammers gain your trust then ask money. Stay alert!
        <br />
        Never transfer money to someone you met online.
        <br />
        If you’ve been scammed, immediately call +60323326000 or the National
        Scam Response Centre at 997 (8am-8pm daily) and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/love_scam.png`,
    imageAlt: "Love Scam Alert",
  },
  {
    id: 12,
    title: "Scam Calls: Spot these red flags",
    date: "Posted on: 21 September 2023",
    content: (
      <p>
        Scammers will try to scare or threaten you during the call. If you feel
        doubtful, just hang up!
        <br />
        If you’ve been scammed, immediately call +603 2332 6000 or the National
        Scam Response Centre at 997 (8am-8pm daily) and make a police report.
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/scam_calls_red_flags.png`,
    imageAlt: "Scam Call Warning",
  },
  {
    id: 13,
    title:
      "Panggilan Scam Parcel: Syarikat kurier tidak akan meminta butiran peribadi anda",
    date: "Posted on: 12 October 2023",
    content: (
      <p>
        Berhati-hati dengan panggilan scam parcel. Jika bukan parcel anda,
        jangan terpedaya!
        <br />
        Jika terkena scam, segera hubungi +603 2332 6000 atau Pusat Respons Scam
        Kebangsaan di 997 (8am - 8pm, setiap hari) dan buat laporan polis.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/panggilan_scam_parcel.png`,
    imageAlt: "Parcel Scam Alert",
  },
  {
    id: 14,
    title: "Dengar Boleh, Berkongsi Jangan",
    date: "Posted on: 19 October 2023",
    content: (
      <p>
        Receive a suspicious call? Put the phone down, check first and protect
        your bank details!
        <br />
        If you’ve been scammed, immediately call +603 2332 6000 or the National
        Scam Response Centre on 997 (8am - 8pm, daily) and make a police report.
        <br />
        #JanganKenaKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/dengar_boleh_jangan_kongsi.png`,
    imageAlt: "Suspicious Call Warning",
  },
  {
    id: 15,
    title: "Jangan muat turun fail .APK musim perayaan ini",
    date: "Posted on: 26 January 2023",
    content: (
      <p>
        Beware of unusual offers and never download any files .APK! If you’ve
        been scammed, immediately call +603-23326000 or the National Scam
        Response Centre at 997 (8am-8pm, daily) and make a police report.
        <br />
        #JanganKenaKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/scam_apk_musim_perayaan.png`,
    imageAlt: "APK File Scam",
  },
  {
    id: 16,
    title: "NSRC tidak akan menghubungi anda!",
    date: "Posted on: 1 February 2023",
    content: (
      <p>
        Berhati-hati dengan scammer yang menyamar sebagai pegawai National Scam
        Response Centre yang menghubungi untuk menyiasat anda kerana scam!
        <br />
        Jika terkena scam, segera hubungi +603 2332 6000 atau Pusat Respons Scam
        Kebangsaan di 997 (8am -8pm, setiap hari) dan buat laporan polis.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/nsrc_scam.png`,
    imageAlt: "NSRC Scam Alert",
  },
  {
    id: 17,
    title: "How to tell if you've fallen for a love scam?",
    date: "Posted on: 9 February 2023",
    content: (
      <p>
        Don't simply trust a stranger just because they made your heart flutter!
        <br />
        If you’ve been scammed, immediately call +603 2332 6000 or the National
        Scam Response Centre at 997 (8am-8pm daily) and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/fallen_love_scam.png`,
    imageAlt: "Love Scam Awareness",
  },
  {
    id: 18,
    title: "Don't get fooled by investment scams!",
    date: "Posted on: 15 February 2023",
    content: (
      <p>
        Always be wary of investment schemes that sound too good to be true.
        <br />
        If you’ve been scammed, immediately call +603 2332 6000 or the National
        Scam Response Centre at 997 (8am-8pm daily) and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/investment_scam.png`,
    imageAlt: "Investment Scam Warning",
    // image:
    //   "https://www.alrajhibank.com.my/images/gallery/240215_InvestmentScam_184.jpg",
  },
  {
    id: 19,
    title:
      "Cara-cara untuk mengelak telefon anda dari terkena perisian hasad (malware)",
    content: (
      <p>
        Sentiasa ambil langkah berwaspada untuk melindungi telefon anda dari
        perisian hasad!
        <br />
        Jika terkena scam, segera hubungi talian Perunding Khidmat Pelanggan
        24/7 alrajhi bank Malaysia di +603 2332 6000 atau Pusat Respons Scam
        Kebangsaan di 997 (8am - 8pm, setiap hari) dan buat laporan polis.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/mengelakkan_malware.png`,
    imageAlt: "Malware Scam Alert",
    // image:
    //   "https://www.alrajhibank.com.my/images/gallery/240222_MalwareScam_StaticImage_BM_185.jpg",
  },
  {
    id: 20,
    title: "How to Spot Job Scam Tactics",
    content: (
      <p>
        Stay safe on your job hunt by learning how to spot suspicious listings!
        If you’ve been scammed, immediately call our alrajhi bank Malaysia 24/7
        Customer Care Consultants at +603 2332 6000 or the National Scam
        Response Centre at 997 (8am-8pm daily) and make a police report.
        <br />
        #JanganKenaScam
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/job_scam.png`,
    imageAlt: "Job Scam Alert",
    // image: [
    //   "https://www.alrajhibank.com.my/images/gallery/240229_JobScam_MultiPost1_EN_1080x1080_noBankLogo_191.jpg",
    //   "https://www.alrajhibank.com.my/images/gallery/240229_JobScam_MultiPost2_EN_1080x1080_noBankLogo_192.jpg",
    //   "https://www.alrajhibank.com.my/images/gallery/240229_JobScam_MultiPost3_EN_1080x1080_noBankLogo_193.jpg",
    //   "https://www.alrajhibank.com.my/images/gallery/240229_JobScam_MultiPost4_EN_1080x1080_noBankLogo_194.jpg",
    //   "https://www.alrajhibank.com.my/images/gallery/240229_JobScam_MultiPost5_EN_1080x1080_noBankLogo_195.jpg",
    // ],
  },
  {
    id: 21,
    title: "Yang mana satu mesej SCAM PANCINGAN DATA?",
    content: (
      <p>
        Scam Pancingan Data tak mudah dikesan. Jadi, hati-hati dengan pautan
        yang mencurigakan! Jika terkena scam, segera hubungi talian Perunding
        Khidmat Pelanggan 24/7 alrajhi bank Malaysia di +603 2332 6000 atau
        Pusat Respons Scam Kebangsaan di 997 (8am - 8pm, setiap hari) dan buat
        laporan polis.
        <br />
        <br />
        <p>#JanganKenaScam</p>
      </p>
    ),
    image: `${ASSETS_BASE_URL}assets/images/fraud-awareness/scam_pancingan_data.png`,
    imageAlt: "SCAM PANCINGAN DATA",
    // image: [
    //   "https://www.alrajhibank.com.my/images/gallery/240307_PhishingScam_MultiPost1_BM_1080x1080_noBankLogo_196.jpg",
    //   "https://www.alrajhibank.com.my/images/gallery/240307_PhishingScam_MultiPost2_BM_1080x1080_noBankLogo_197.jpg",
    // ],
  },
];
